document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.testimonial-slider');
    const testimonials = Array.from(document.querySelectorAll('.testimonial-item'));
    const rightArrow = document.querySelector('.arrow-right');
    const itemsPerSlide = 3; 
    let currentIndex = 0;
    const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

    const updateSlider = () => {
        slider.style.transform = `translateX(-${(currentIndex % totalSlides) * (300 / itemsPerSlide)}%)`;
    };


    rightArrow.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
    });

    updateSlider();
});
